module.exports = "<ng-content></ng-content><a class=\"card-link ml-2\" (click)=\"openModal()\">(change name)</a>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/renamable/renamable.component.html
// module id = ../../../../../src/app/renamable/renamable.component.html
// module chunks = main